import logo_icon from './logo_icon.png';
import { useAppContext } from '../../shared';

export const Logo = () => {
  const { meta } = useAppContext();

  return (
    <div className="pb-lg grow w-full text-center flex items-center gap-x-lg">
      <img alt="Logo" src={logo_icon} />
      <span className="font-bold text-section">
        {meta.tenant.name || ' - '}
      </span>
    </div>
  );
};
